import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@recruitee/analytics';

export type TrackAutomateConsentRequestsProps = {
  enabled: boolean;
  excludeQualified: boolean;
  excludeWithEmailActivity: boolean;
};

export type TrackAutomateCandidateDeletionDisabledProps = {
  deleteExpired: boolean;
  deleteRequested: boolean;
  deleteNoConsent: boolean;
};
export type TrackAutomateCandidateDeletionEnabledProps =
  TrackAutomateCandidateDeletionDisabledProps & {
    excludeQualified: boolean;
    excludeWithEmailActivity: boolean;
  };

@Injectable()
export class GdprAutomationsAnalyticsService extends AnalyticsBase {
  public readonly namespace = 'GDPRAutomations';
  public readonly requireViewContext = true;

  public trackAutomateConsentRequests(props: TrackAutomateConsentRequestsProps): void {
    this.track('AutomateConsentRequests', props);
  }

  public trackEmailExpiringCandidates(actionTaken: 'skip' | 'send'): void {
    this.track('EmailExpiringCandidates', { actionTaken });
  }

  public trackAutomateCandidateDeletion(
    props: TrackAutomateCandidateDeletionDisabledProps | TrackAutomateCandidateDeletionEnabledProps,
  ): void {
    this.track('AutomateCandidateDeletion', props);
  }
}
